var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ChangeProfilePicture',{attrs:{"loading":_vm.loading,"user-profile":_vm.userProfile}}),_c('ChangeProfileAttributes',{attrs:{"loading":_vm.loading,"user-profile":_vm.userProfile}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }